import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import MoonDivider from "@/components/MoonDivider";

const ORDER = ["adonis", "muse", "karma"];
const orderIndex = (name = "") => {
  const i = ORDER.findIndex((k) => name.toLowerCase().includes(k));
  return i === -1 ? ORDER.length : i;
};

export default function Shop() {
  const [params] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const search = params.get("search") || "";

  useEffect(() => {
    setLoading(true);
    const q = {};
    if (search) q.search = search;
    api.get("/products", { params: q })
      .then((r) => setProducts([...r.data].sort((a, b) => orderIndex(a.name) - orderIndex(b.name))))
      .finally(() => setLoading(false));
  }, [search]);

  return (
    <div className="max-w-7xl mx-auto px-6 py-14" data-testid="shop-page">
      <div className="text-center mb-4">
        <p className="font-body uppercase tracking-[0.35em] text-xs text-gold mb-3">The Boutique</p>
        <h1 className="font-serif text-5xl sm:text-6xl text-cream">Shop All</h1>
      </div>
      <MoonDivider />

      {search && (
        <p className="text-center font-body text-sm text-white/50 mt-6">
          Results for <span className="text-gold">"{search}"</span>
        </p>
      )}

      <div className="mt-10">
        {loading ? (
          <p className="text-center font-serif text-xl text-white/40 py-20">Unveiling temptations…</p>
        ) : products.length === 0 ? (
          <p className="text-center font-serif text-xl text-white/40 py-20" data-testid="no-products">No confections found.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
